import {
  mapActions
} from 'vuex';
import ForgetPasswordI18n from './ForgetPassword.i18n.js';

export default {

  components: {},

  props: {},

  computed: {},

  data() {
    return {
      email: '',
      validMail: null,
      resetSuccess: false,
      unknownMail: false,
      error: false
    };
  },

  watch: {
    email(value) {
      this.validateEmail(value)
    }
  },

  methods: {
    ...mapActions(['forgotPassword']),
    forgotCurrentPassword() {
      const info = {
        email: this.email
      }
      this.forgotPassword(info).then(res => {
        this.resetSuccess = true
        this.unknownMail = false
        this.error = false
      }).catch(err => {
        if (err.response.status === 404) {
          this.unknownMail = true
        } else {
          this.error = true
        }

        console.log(err)
      })
    },

    validateEmail(pEmail) {
      if (pEmail !== '') {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(pEmail)) {
          this.validMail = true
        } else {
          this.validMail = false
        }
      } else {
        this.validMail = null
      }
    }
  },

  mounted() {
    window.scrollTo(0, 0)
  },

  i18n: ForgetPasswordI18n,

};